// extracted by mini-css-extract-plugin
export var baseButton = "_qh-0";
export var controlsArrowKeys = "_qh-1";
export var controlsResetButton = "_qh-2";
export var lightGameButton = "_qh-4 _qh-0";
export var playAgainButton = "_qh-5 _qh-0";
export var startGameButton = "_qh-3 _qh-0";